import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { JJamesPaginationConfig } from '../../../types/ui.types';
import { ResponsiveBaseComponent } from '../../responsive/responsive';

@Component({
  selector: 'jjames-paginator',
  imports: [CommonModule, MatPaginatorModule],
  templateUrl: './jjames-paginator.component.html',
  styleUrls: ['./jjames-paginator.component.scss']
})
export class JJamesPaginatorComponent extends ResponsiveBaseComponent {
  @Input({ required: true }) config!: JJamesPaginationConfig;
  @Input() showFirstLastButtons: boolean = true;
  @Input() ariaLabel: string = 'Select page';
  @Output() pageChange = new EventEmitter<PageEvent>();

  onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }
}